import { mapActions } from 'vuex'

export const duplicate = {
	data () {
		return {
			isCreatingDuplicate : false,
		}
	},
	computed : {
		canMobile () {
			return [ 'floating', 'popup' ].includes(this.type)
		},
	},
	methods : {
		...mapActions('campaigns', [ 'duplicateCampaign' ]),
		duplicating (status) {
			this.isCreatingDuplicate = status
		},
		duplicate () {
			if (!this.isValid()) {
				return
			}

			this.duplicating(true)

			this.duplicateCampaign({
				campaignId : this.campaign.id,
				params     : {
					name   : this.name,
					notes  : this.notes,
					mobile : this.canMobile && this.mobile,
					type   : this.type,
				},
			})
				.then(() => {
					this.$store.commit('campaigns/addAlert', {
						message : `The ${this.campaign.name} campaign was duplicated successfully.`,
						type    : 'success',
					})
				})
				.finally(() => {
					this.duplicating(false)
					this.$modal.hide(this.campaign.id + '-duplicate-modal')
				})
		},
		isValid () {
			if (!this.name) {
				this.error = 'A name is required for the duplicate campaign.'
				return false
			}

			return true
		},
	},

}
